import store from '../store'
import * as types from '../store/mutation-types'


let utils = {
    /**
     * 将路由中的:id参数转化为链接
     * :id在obj找到对应的取值
     * @param {*} route
     * @param {*} obj
     * @param {*} method url请求类型，如果是POST,将返回一个对象，包含着上传的id参数
     */
    getPath (path, obj, method = 'GET') {
        // 路由处理
        let pathname = '' // 完整路由
        let route = path.split('/:') // 分割参数
        let params = {} // 链接中的参数，作为上传参数提交
        // 标识，是否是等号
        let isFuzhi = false
        if (route.length < 2) {
            isFuzhi = true
            route = path.split('=:') // 分割参数
        }
        // 2019-01-04添加，针对xxx.com?id=:id&a=:a&b=:b 这种多个参数的处理
        // 之前的牵扯太多，暂时不动，就在这里hack一下
        if (isFuzhi && route.length > 2) {
            let splitArr = path.split(':')
            for (let k in splitArr) {
                if (k > 0) {
                    let markIndex = splitArr[k].indexOf('&') 
                    if (splitArr[k].indexOf(';') > 0) {
                        markIndex = splitArr[k].indexOf(';')
                    }
                    // 分割带有&/;的情况: id&a= , modules;comp=
                    if (markIndex > 0) {
                        let mark = splitArr[k].substring(0, markIndex)
                        let defaultValue = '' // 变量的默认值
                        let defaultIndex = mark.indexOf('||')
                        if (defaultIndex > 0) {
                            defaultValue = mark.substring(defaultIndex + 2)
                            mark = mark.substring(0, defaultIndex)
                        }   
                        let markStr = obj[mark]
                        if (markStr == undefined) {
                            pathname +=":" + splitArr[k]
                        } else {
                            // url上替换的参数
                            let replaceStr = mark
                            if (defaultIndex > 0) {
                                replaceStr += '||' + defaultValue
                                if (String(markStr).length < 1) {
                                    markStr = defaultValue
                                }
                            }
                            pathname += splitArr[k].replace(replaceStr, markStr)
                        }
                    } else {
                        if (obj[splitArr[k]]) {
                            pathname += obj[splitArr[k]]
                        } else {
                            pathname += ':' + splitArr[k]
                        }
                    }
                } else {
                    pathname += splitArr[k]
                }
            }
        } else {
            for (let i = 0, len = route.length; i < len; i++) {
                if (i > 0) { // 使用当前行参数，对应字段拼接到路由上
                    if (method == 'POST') {
                        params[route[i]] = obj[route[i]]
                    } else {
                        // 这里做一个二级判断，满足api/member/:id/dir 这种模式
                        let p = route[i].split('/')
                        if (isFuzhi) {
                            pathname += '=' + obj[p[0]]
                        } else {
                            pathname += '/' + obj[p[0]]
                        }
                        if (p.length == 2) {
                            pathname += '/' + p[1]
                        }
                    }
                } else {
                    pathname += route[i]
                }
            }
        }
        // 如果有将 store中的userID传入
        if (pathname.indexOf('#userId') > 0) {
            pathname = pathname.replace('#userId', store.getters.userInfo.id)
        }
        console.log('pathname', pathname)
        return method == 'POST' ? {
            url: pathname,
            params: params
        } : pathname
    },
     /**
     * 全局路由钩子处理函数
     * @param  {[Object]}   options.meta [路由上的参数]
     * @param  {[String]}   options.path [路由要进入的路径地址]
     * @param  {[String]}   from         [当前导航正要离开的路由]
     * @param  {Function}   next         [进行管道中的下一个钩子]
     */
    globalRouterBeforeEach ({path, meta, fullPath}, from, next) {
        if (!store.getters.authorizd && path !== store.getters.loginRouter) { // 未登录状态
            let tokon = null
            // 2020-10-08这里是有问题的，但不想改
            if (path.indexOf(store.getters.tokonMark) === 0) { // 跳转路径是否带tokon参数
                // 获得链接上的TOKON值
                tokon = path.substring(5, path.length)
                // 本地存储TOKON
                utils.saveTokon(tokon)
                // MARK 标识过来的设置 path 为根目录
                path = store.getters.rootRoute
            } else { // 本地获取是否有tokon
                tokon = utils.getCookie(store.getters.tokonKey)
                if (tokon) {
                    tokon = tokon.replace('%20', ' ')
                }
            }
            // 有tokon时
            if (tokon && tokon.length > 0) {
                // 1、将tokon存放到vuex中
                store.commit(types.UPDATE_TOKON, tokon)
                // 2、改变authorizd状态
                store.commit(types.UPDATE_AUTHORIZD, true)
                next({path: path})
            } else { // 无Tokon时，跳转到登录页面
                next({ path: store.getters.loginRouter, query: {redirect: path} })
            }
        } else if (store.getters.authorizd && path === store.getters.loginRouter) { // 已登录，再跳转到login路由的拦截
            next('/')
        } else {
            next()
        }
    },
     /**
     * 本地存储tokon
     * @param  {[type]} tokon [description]
     * @return {[type]}       [description]
     */
    saveTokon (tokon) {
        // 设置有效期15天
        let expireDays = 1000 * 60 * 60 * 24 * 15
        utils.setCookie(store.getters.tokonKey, tokon, expireDays)
    },
    /**
     * 设置cookie
     */
    setCookie (key, value, expiredays) {
        var exdate = new Date()
        exdate.setDate(exdate.getDate() + expiredays)
        document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())
    },
    /**
     * 获取cookie
     */
    getCookie (name) {
        var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
        var arr = document.cookie.match(reg)
        if (arr) {
            return (arr[2])
        } else {
            return null
        }
    },
    /**
     * 删除cookie
     */
    delCookie (name) {
        var exp = new Date()
        exp.setTime(exp.getTime() - 1)
        var cval = utils.getCookie(name)
        if (cval != null) {
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()
        }
    },
    /**
     * 退出登录
     */
    loginOut () {
        // 1、改变授权状态
        store.commit(types.UPDATE_AUTHORIZD, false)
        // 2、删除cookie
        utils.delCookie(store.getters.tokonKey)
    },
    /**
     * 打开新窗口
     */
    openNewWindow (url, id = "openAId"){
        var a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('target', '_blank');
        a.setAttribute('id', id);
        // 防止反复添加
        if(!document.getElementById(id)) {
            document.body.appendChild(a);
        }
        a.click();
    }
}

export default utils



// WEBPACK FOOTER //
// ./src/utils/path.js